import BreadCrumbs from '@/components/atom/BreadCrumbs';
import PaginationComponent from '@/components/common/PaginationComponent';
import LinkTag from '@/components/common/link-tag';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { zIndex } from '@/constants/zIndex';
import DNSearchBar from '@/design-components/organisms/dnsearch-bar';
import { DiseaseEncyclopedia } from '@/entities/disease-encyclopedia';
import { DiseaseEncyclopediaEmptyState } from '@/features/disease-encyclopedia';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import { DiseaseEncyclopediaSearchViewModel } from '@/views/disease-encyclopedia/search/hooks/useDiseaseEncyclopediaSearchViewModel';
import React from 'react';

interface Props {
  viewModel: DiseaseEncyclopediaSearchViewModel;
  client: Client;
}

const DiseaseEncyclopediaSearchView = (props: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {props.client.clientType === ClientType.WEB && (
        <BreadCrumbs.Wrapper>
          <BreadCrumbs
            visible
            name='검색결과'
            type='disease_encyclopedia'
            path={`${ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path}`}
          />
        </BreadCrumbs.Wrapper>
      )}

      <div className='typography-ui-22sb px-[24px] py-[16px] text-gray-900'>질환백과</div>

      <div
        className='px-[24px] py-[16px]'
        style={{
          zIndex: zIndex.AppHeader,
          top: props.client.clientType === ClientType.MOBILE_WEB ? '60px' : '0px',
        }}
      >
        <DNSearchBar
          value={props.viewModel.keyword}
          placeholder={'질환 이름 혹은 증상 검색'}
          shouldShowResetButton={!!props.viewModel.keyword}
          searchInputRef={props.viewModel.searchInputRef}
          onSubmit={props.viewModel.handleSubmit}
          onReset={props.viewModel.handleResetSearchKeyword}
          onChange={props.viewModel.handleChangeSearchKeyword}
        />
      </div>

      <div className='pt-[16px] pb-[80px]'>
        <div className='mb-[20px] flex items-center gap-[4px] px-[24px]'>
          <h2 className='typography-ui-17m text-gray-700'>검색결과</h2>
          <span className='typography-ui-17m text-primary-600'>{props.viewModel.totalCount}</span>
        </div>
        {props.viewModel.keywordSearchDiseaseEncyclopedia?.elements?.length === 0 ? (
          <DiseaseEncyclopediaEmptyState />
        ) : (
          <>
            <div className='grid grid-cols-1 gap-[20px]'>
              {props.viewModel.keywordSearchDiseaseEncyclopedia?.elements?.map((diseaseEncyclopedia, index, array) => (
                <React.Fragment key={diseaseEncyclopedia.getPublicId()}>
                  <div className='px-[24px]' key={diseaseEncyclopedia.getPublicId()}>
                    <LinkTag
                      href={`${ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path}/${diseaseEncyclopedia.getPublicId()}`}
                      onClickNavigateToScreen={props.viewModel.onClickDiseaseEncyclopedia(diseaseEncyclopedia)}
                    >
                      <DiseaseEncyclopedia
                        key={diseaseEncyclopedia.getPublicId()}
                        title={diseaseEncyclopedia.getTitle()}
                        summary={diseaseEncyclopedia.getContent()}
                        image={diseaseEncyclopedia.getTitleImageUrl() ?? undefined}
                      />
                    </LinkTag>
                  </div>
                  {index !== array.length - 1 && <div className='h-[1px] w-full bg-gray-40' />}
                </React.Fragment>
              ))}
            </div>
            <PaginationComponent
              baseUrl={ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path}
              queries={props.viewModel.queries}
              currentPage={props.viewModel.currentPage}
              perPage={5}
              totalPage={props.viewModel.totalPage}
            />
          </>
        )}
      </div>
    </TemplateLayout.Wrapper>
  );
};

export default DiseaseEncyclopediaSearchView;
